import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Header from "../../layouts/Header";
import SingleSelectDropDown from "../../layouts/SingleSelectDropDown";
import EnvConfigTable from "./EnvConfigTable";
import CopyEnvConfigModal from "./CopyEnvConfigModal";
import AddEnvConfigModal from "./AddEnvConfigModal";
import { RESET_ENV_CONFIG_SORTING_COLUMNS } from "../../utils/constant.js";
import { axios_instance } from "../../api/axios_instance.js";
import {
  decryptRequest,
  encryptRequest,
} from "../../utils/encryptdecryptrequest.js";
import { ToastContainer, toast } from "react-toastify";

const EnvConfig = () => {
  const initialState = {
    ENVDATA: [],
    total: 0,
    EnvTypes: [],
    filterValues: {
      envType: "",
      key: "",
      value: "",
    },
    sortingColumns: { ...RESET_ENV_CONFIG_SORTING_COLUMNS, id: 1 },
    envConfigCheckboxes: {},
    allCheckboxesSelected: false,
    page: 1,
    showNavigationModal: false,
    showArrowTopButton: false,
    showDeleteButton: false,
    showCopyEnvConfigModal: false,
    showAddConfigModal: false,
    editEnvConfigProps: {},
    user: useSelector((state) => state.user),
    isLoading: false,
  };

  const [envConfigState, setEnvConfigState] = useState(initialState);
  const [deleteEnvDetails, setDeleteEnvDetails] = useState([]);

  const fetchConfigData = async (
    closeAddEnvConfigModal,
    closeCopyEnvConfigModal
  ) => {
    try {
      if (closeAddEnvConfigModal) {
        setEnvConfigState((prevState) => ({
          ...prevState,
          showAddConfigModal: false,
        }));
      }

      if (closeCopyEnvConfigModal) {
        setEnvConfigState((prevState) => ({
          ...prevState,
          showCopyEnvConfigModal: false,
        }));
      }

      const reqData = encryptRequest({
        filterValues: envConfigState.filterValues,
        sortingColumns: envConfigState.sortingColumns,
        page: envConfigState.page,
      });

      const configData = await axios_instance({
        url: "/envConfig/getEnvConfigData",
        method: "POST",
        data: { reqData },
      });
      if (configData.status === 200) {
        const decryptedData = decryptRequest(configData.data.resData);
        setEnvConfigState((prevState) => ({
          ...prevState,
          ENVDATA: decryptedData.pageOfResults,
          total: decryptedData.total,
          EnvTypes: decryptedData.EnvTypes,
        }));
      }
    } catch (error) {
    } finally {
      setEnvConfigState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  useEffect(() => {
    setEnvConfigState((prevState) => ({ ...prevState, isLoading: true }));
    fetchConfigData();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [envConfigState.page, envConfigState.sortingColumns]);

  const handleInputChange = (e, filterName) => {
    setEnvConfigState({
      ...envConfigState,
      filterValues: {
        ...envConfigState.filterValues,
        [filterName]: e.target.value,
      },
    });
  };

  const searchList = async (e) => {
    e.preventDefault();
    setEnvConfigState({ ...envConfigState, isLoading: true });
    await fetchConfigData();
  };

  const [resetClicked, setResetClicked] = useState(false);

  useEffect(() => {
    if (resetClicked) {
      // envConfigState.filterValues = initialState.filterValues;
      // envConfigState.sortingColumns = { ...RESET_ENV_CONFIG_SORTING_COLUMNS };
      // envConfigState.page = 1;

      setEnvConfigState((prevState) => ({
        ...prevState,
        filterValues: initialState.filterValues,
        sortingColumns: { ...RESET_ENV_CONFIG_SORTING_COLUMNS, id: 1 },
        page: 1,
      }));

      fetchConfigData();
      setResetClicked(false);
    }
  }, [resetClicked]);

  const resetFunc = async (e) => {
    e.preventDefault();
    setEnvConfigState({ ...envConfigState, isLoading: true });
    setResetClicked(true);
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setEnvConfigState((prevState) => ({
        ...prevState,
        showArrowTopButton: true,
      }));
    } else {
      setEnvConfigState((prevState) => ({
        ...prevState,
        showArrowTopButton: false,
      }));
    }
  };

  const handleSorting = async (filterName) => {
    setEnvConfigState({ ...envConfigState, isLoading: true });
    let sortingColumns = envConfigState.sortingColumns;
    const order = [0, -1].includes(sortingColumns[filterName]) ? 1 : -1;
    sortingColumns = { ...RESET_ENV_CONFIG_SORTING_COLUMNS };
    sortingColumns[filterName] = order;
    setEnvConfigState((prevState) => ({ ...prevState, sortingColumns }));
  };

  const handleEnvConfigTableCheckboxChange = (e, id, deleteEnvObj = {}) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      let deleteEnvDetailsArr = [];
      const toggleAllCheckboxes = !envConfigState.allCheckboxesSelected;
      envConfigState.ENVDATA.forEach((envVal) => {
        envConfigState.envConfigCheckboxes[envVal.id] = toggleAllCheckboxes;
        deleteEnvDetailsArr.push({
          id: envVal.id,
          env_id: envVal.env_type_id,
          param_key: envVal.param_key,
        });
      });
      envConfigState.allCheckboxesSelected = toggleAllCheckboxes;
      if (!toggleAllCheckboxes) deleteEnvDetailsArr = [];
      setDeleteEnvDetails(deleteEnvDetailsArr);
    } else {
      let deleteEnvDetailsArr = deleteEnvDetails;
      if (checked) {
        deleteEnvDetailsArr.push(deleteEnvObj);
      } else {
        deleteEnvDetailsArr = deleteEnvDetailsArr.filter((deleteVal) => {
          return +deleteVal.id !== +id;
        });
        envConfigState.allCheckboxesSelected = false;
      }
      envConfigState.envConfigCheckboxes[id] = checked;
      setDeleteEnvDetails(deleteEnvDetailsArr);
    }
    setEnvConfigState({
      ...envConfigState,
      showDeleteButton: areCheckboxesChecked(),
    });
  };

  const areCheckboxesChecked = () => {
    let areChecked = false;
    envConfigState.ENVDATA.forEach((envVal) => {
      if (envConfigState.envConfigCheckboxes[envVal.id]) {
        areChecked = true;
        return;
      }
    });
    return areChecked;
  };

  const pageSelected = (e, pageNo) => {
    e.preventDefault();
    setEnvConfigState({ ...envConfigState, page: pageNo });
  };

  const prevPage = (e) => {
    e.preventDefault();
    setEnvConfigState({
      ...envConfigState,
      page: envConfigState.page - 1,
    });
  };

  const nextPage = (e) => {
    e.preventDefault();
    setEnvConfigState({
      ...envConfigState,
      page: envConfigState.page + 1,
    });
  };

  const openAddEnvConfigModal = (e, values = {}) => {
    setEnvConfigState({
      ...envConfigState,
      showAddConfigModal: true,
      editEnvConfigProps: values,
    });
    e.stopPropagation();
  };

  const syncEnvData = async () => {
    toast.dismiss();
    try {
      setEnvConfigState({ ...envConfigState, isLoading: true });
      const configData = await axios_instance({
        url: "/envConfig/syncEnvData",
        method: "GET",
      });
      if (configData.status === 200) {
        toast.success(
          configData.data.result.msg
            ? configData.data.result.msg
            : "Data Synced Successfully",
          { theme: "colored" }
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message, { theme: "colored" });
      } else {
        toast.error("Something went wrong", { theme: "colored" });
      }
    } finally {
      setEnvConfigState({ ...envConfigState, isLoading: false });
    }
  };

  const deleteEnvData = async () => {
    try {
      setEnvConfigState((prevState) => ({ ...prevState, isLoading: true }));
      const reqData = encryptRequest({
        deleteEnvDetails,
        action: envConfigState.allCheckboxesSelected ? "all" : "",
      });
      const configData = await axios_instance({
        url: "/envConfig/deleteEnvConfigData",
        method: "DELETE",
        data: { reqData },
      });
      if (configData.status === 200) {
        await fetchConfigData(false, false);
        toast.success(
          configData.data.result.msg
            ? configData.data.result.msg
            : "Data Deleted Successfully",
          { theme: "colored" }
        );
        setDeleteEnvDetails([]);
        setEnvConfigState((prevState) => ({
          ...prevState,
          showDeleteButton: false,
          envConfigCheckboxes: {},
          allCheckboxesSelected: false,
        }));
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.err, { theme: "colored" });
      } else {
        toast.error("Something went wrong", { theme: "colored" });
      }
    } finally {
      setEnvConfigState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  return (
    <span>
      <ToastContainer
        closeOnClick={false}
        draggable={false}
        closeButton={false}
      />
      <Header
        isNavigationModal={envConfigState.showNavigationModal}
        closeNavigationModal={() =>
          setEnvConfigState({
            ...envConfigState,
            showNavigationModal: false,
          })
        }
        openNavigationModal={() =>
          setEnvConfigState({
            ...envConfigState,
            showNavigationModal: true,
          })
        }
      ></Header>
      {envConfigState.showCopyEnvConfigModal ? (
        <CopyEnvConfigModal
          EnvTypes={envConfigState.EnvTypes}
          fetchConfigData={fetchConfigData}
          closeCopyEnvConfigModal={() =>
            setEnvConfigState({
              ...envConfigState,
              showCopyEnvConfigModal: false,
            })
          }
        />
      ) : (
        ""
      )}
      {envConfigState.showAddConfigModal && (
        <AddEnvConfigModal
          editEnvConfigProps={envConfigState.editEnvConfigProps}
          EnvTypes={envConfigState.EnvTypes}
          fetchConfigData={fetchConfigData}
          closeAddEnvConfig={() =>
            setEnvConfigState({
              ...envConfigState,
              showAddConfigModal: false,
            })
          }
        />
      )}

      <div className="container-fluid">
        <div className="row">
          <div className="main_wrapper">
            <div className="overlay" id="navigation-overly"></div>
            <div className="panel-white">
              <section className="right_wrapper">
                <div className="filter_flyout">
                  <div className="filter_box fm-filter filter-section-bx" id="">
                    <div className="row pad-L10">
                      <form id="form-filter">
                        <div className="clearfix">
                          <div className="col-md-3 col-xs-12 rc-reg-no has-feedback">
                            <SingleSelectDropDown
                              dataArr={envConfigState.EnvTypes}
                              handleChange={(e) =>
                                handleInputChange(e, "envType")
                              }
                              name="config_envtype_filter"
                              value={envConfigState.filterValues.envType}
                            />
                          </div>
                          <div className="col-md-2 col-xs-12">
                            <div className="form-group">
                              <div className="form-group">
                                <input
                                  style={{ paddingRight: "0px" }}
                                  type="text"
                                  id="config_key_filter"
                                  className="form-control"
                                  placeholder="Key"
                                  onChange={(e) => handleInputChange(e, "key")}
                                  name="key_filter"
                                  value={envConfigState.filterValues.key}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 col-xs-12">
                            <div className="form-group">
                              <div className="form-group">
                                <input
                                  style={{ paddingRight: "0px" }}
                                  type="text"
                                  id="config_value_filter"
                                  className="form-control"
                                  placeholder="Value"
                                  onChange={(e) =>
                                    handleInputChange(e, "value")
                                  }
                                  name="value_filter"
                                  value={envConfigState.filterValues.value}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3 pad-LR">
                            <button
                              type="submit"
                              className="btn rc-btn_primary pad-L20 pad-R20 mar-R3 searchResults"
                              disabled={envConfigState.isLoading}
                              onClick={searchList}
                            >
                              {envConfigState.isLoading
                                ? "Please wait.."
                                : "Search"}
                            </button>
                            <button
                              type="button"
                              className="btn rc-btn_rset pad-L20 pad-R20"
                              onClick={resetFunc}
                              disabled={envConfigState.isLoading}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="panel-white">
                  <div className="grayFiltr-bg brdr-FB clearfix">
                    <div className="col-md-12 ">
                      <span className="pull-left env-config-title">
                        Manage Env Config
                      </span>
                      <div className="directory_action pull-right">
                        {envConfigState.showDeleteButton ? (
                          <button
                            className="btn btn-danger pad-L10 pad-R10"
                            id="delete_env_config"
                            onClick={deleteEnvData}
                          >
                            <span className="fa fa-trash font-14 mrg-R5"></span>{" "}
                            Delete Selected{" "}
                          </button>
                        ) : (
                          ""
                        )}

                        <button
                          className="btn rc-btn_rset pad-L10 pad-R10 env-config-buttons"
                          id="copy_env_config"
                          onClick={(e) => {
                            setEnvConfigState({
                              ...envConfigState,
                              showCopyEnvConfigModal: true,
                            });
                            e.stopPropagation();
                          }}
                          disabled={envConfigState.isLoading}
                        >
                          <span className="fa fa-copy font-14 mrg-R5"></span>
                          Copy Env Config
                        </button>
                        <button
                          id="add_new_config"
                          className="btn rc-btn_primary env-config-buttons"
                          title="Add New Env Config"
                          type="button"
                          disabled={envConfigState.isLoading}
                          onClick={openAddEnvConfigModal}
                        >
                          <span className="exprt_excl_icon">
                            <i className="fa fa-plus"></i> Add New
                          </span>
                        </button>
                        <button
                          id="sync_json_file"
                          className="btn rc-btn_primary env-config-buttons"
                          title="Sync Env Config"
                          type="button"
                          disabled={envConfigState.isLoading}
                          onClick={syncEnvData}
                        >
                          <span className="exprt_excl_icon">
                            <i
                              className={`fa fa-refresh ${
                                envConfigState.isLoading ? " fa-spin" : ""
                              } `}
                            ></i>{" "}
                            Refresh/Sync
                          </span>
                        </button>
                        <button
                          className="btn rc-btn_rset env-config-buttons"
                          id="selectAllBtn"
                          name="selectall"
                          onClick={(e) =>
                            handleEnvConfigTableCheckboxChange(e, -1)
                          }
                        >
                          {`${
                            envConfigState.allCheckboxesSelected
                              ? "Unselect"
                              : "Select"
                          } All`}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid" id="list_data">
                    <div className="list-box mrg-B20">
                      <div
                        className="tab-content ad-fx-cls"
                        style={{ marginTop: "0px" }}
                      >
                        {!envConfigState.isLoading ? (
                          <EnvConfigTable
                            ENVDATA={envConfigState.ENVDATA}
                            total={envConfigState.total}
                            sortingColumns={envConfigState.sortingColumns}
                            handleSorting={handleSorting}
                            envConfigCheckboxes={
                              envConfigState.envConfigCheckboxes
                            }
                            handleEnvConfigTableCheckboxChange={
                              handleEnvConfigTableCheckboxChange
                            }
                            page={envConfigState.page}
                            pageSelected={pageSelected}
                            prevPage={prevPage}
                            nextPage={nextPage}
                            openAddEnvConfigModal={openAddEnvConfigModal}
                          />
                        ) : (
                          <div
                            id="dtsMycase_processing"
                            className="dataTables_processing"
                            style={{ textAlign: "center" }}
                          >
                            <img
                              src={`${process.env.REACT_APP_STYLES_PATH}page-loader.gif`}
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="arrowTop">
        {envConfigState.showArrowTopButton ? (
          <div className="pageToup">
            <button
              id="go-top"
              onClick={() =>
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
              }
            >
              <span className="fa fa-arrow-up" aria-hidden="true"></span>
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </span>
  );
};

export default EnvConfig;
